import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-supporters',
    templateUrl: './supporters.component.html',
    styleUrls: ['./supporters.component.scss'],
    standalone: false
})
export class SupportersComponent {
  @Input() forFooter = true;
  @Input() hostname = '';
}
